import { render, staticRenderFns } from "./InquiriesOffersTableView.vue?vue&type=template&id=58fbc9c0&lang=true"
import script from "./InquiriesOffersTableView.vue?vue&type=script&lang=js"
export * from "./InquiriesOffersTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports